/**
 * Isolate the context in an IIFE
 *
 * @param object $ jQuery object
 * @param object Drupal Drupal object
 * @param window window Current window object
 * @param document document Current document object
 */

(function ($, Drupal, window/* , document */) {
  const $window = $(window);
  /**
   * Main script for the current theme
   */
  Drupal.behaviors.themeJS = {
    /**
     * Trigger this function when the pages and Drupal js core was loaded
     *
     * @param object context Dom element triggered this method
     * @param object settings Curent Drupal settings
     *
     */
    attach (context/* , settings */) {
      /* Show and hide header on scrolling. */
      const SCROLL_THRESHOLD = 200;
      const CLASS_SCROLLED = 'js-did-scroll';

      const $body = $('body', context);

      $window.on('scroll', () => {
        const offsetTop = $window.scrollTop();
        const didPassThreshold = offsetTop > SCROLL_THRESHOLD;

        if (didPassThreshold && !$body.hasClass(CLASS_SCROLLED)) {
          $body.addClass(CLASS_SCROLLED);
        } else if (!didPassThreshold && $body.hasClass(CLASS_SCROLLED)) {
          $body.removeClass(CLASS_SCROLLED);
        }
      });
    },
  };

  /**
   * Add the menu toggle Search for the desktop menu.
   */
  Drupal.behaviors.searchDesktopToggle = {
    attach (context) {
      once('desktopMenuSearch', '.region-header-right-part', context).forEach((headerRight) => {
        const button = headerRight.querySelector('.search-button-toggle');
        // @todo The selector will be changed after BE will have done.
        const searchInput = document.querySelector('.region-search input.form-search');

        // Show/hide Search block.
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const isExpanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
          headerRight.classList.toggle('search-open');

          if (headerRight.classList.contains('search-open')) {
            searchInput.focus();
          }

          const regionMobileNavigation = document.querySelector('.region-mobile-navigation');
          if (regionMobileNavigation.classList.contains('open')) {
            regionMobileNavigation.classList.remove('open');
            headerRight.querySelector('.menu-button-toggle').setAttribute('aria-expanded', 'false');
          }
        });
      });
    },
  };

  /**
   * Add the menu toggle.
   */
  Drupal.behaviors.mobileMenuToggle = {
    attach (context) {
      once('mobileMenuToggle', '.region-header-right-part', context).forEach((headerRight) => {
        const button = headerRight.querySelector('.menu-button-toggle');

        // Show/hide Search block.
        button.addEventListener('click', (e) => {
          e.preventDefault();
          const isExpanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
          headerRight.classList.toggle('menu-open');
          document.querySelector('.region-mobile-navigation').classList.toggle('open');

          const regionHeader = document.querySelector('.region-header-right-part');
          if (regionHeader.classList.contains('search-open')) {
            regionHeader.classList.remove('search-open');
          }
        });
      });
    },
  };

  /**
   * Add the wrapper for the tables.
   */
  Drupal.behaviors.responsiveCSVTable = {
    attach (context) {
      once('generalTables', '.text-formatted table', context).forEach((table) => {
        if (table.closest('div').classList.contains('table-responsive')) {
          return;
        }

        const wrapper = document.createElement('div');
        wrapper.classList.add('table-responsive');
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      });
    },
  };

  /**
   * Add the auto-focus to search results element for a11y
   */
  Drupal.behaviors.focusViewsResults = {
    attach: (context) => {
      // Check if the URL has query parameters
      if (window.location.search) {
        const viewsResults = context.querySelector('.views-results');

        if (viewsResults) {
          setTimeout(() => {
            viewsResults.setAttribute('tabindex', '0'); // Make the element focusable
            viewsResults.focus(); // Move focus to the element

            // Scroll smoothly to the element
            viewsResults.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 500);
        }
      }
    },
  };
}(jQuery, Drupal, window, document));
